import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IBankAccountTypesState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState: IBankAccountTypesState = {
  list: [],
  isLoading: false,
};
